import { render } from "./StockOption.vue?vue&type=template&id=19c93c0d&scoped=true&ts=true"
import script from "./StockOption.vue?vue&type=script&lang=ts"
export * from "./StockOption.vue?vue&type=script&lang=ts"

import "./StockOption.vue?vue&type=style&index=0&id=19c93c0d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c93c0d"]])

export default __exports__